<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">{{ $t("policy.name") }} "{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("policy.new") }}</span>
      </h2>

      <div class="row">
        <div class="col-md-4">
          <h6 class="mt-3">{{ $t("policy-category.text") }}</h6>
          <filter-select
            key="policyCategoryFilter"
            id="policyCategoryFilter"
            ref="policyCategoryFilter"
            placeholder="Tedbir Kategorisi"
            :selected="form.category"
            @filter="onPolicyCategorySearch"
            @changed="onPolicyCategorySelect"
          />
        </div>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-3">
              <sweet-input class="mt-3" v-model="form.no" :isValid="!$v.form.no.$error" @input="$v.form.no.$touch()" layout="vertical" type="number" placeholder="No" label="No" />
            </div>
            <div class="col-md-9">
              <sweet-input
                class="mt-3"
                v-model="form.name"
                :isValid="!$v.form.name.$error"
                @input="$v.form.name.$touch()"
                layout="vertical"
                :placeholder="$t('policy.name')"
                :label="$t('policy.name')"
              />
            </div>
          </div>
        </div>
      </div>

      <b-form-tags v-model="form.products" size="lg" class="mb-2 mt-4" add-on-change no-outer-focus>
        <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
          <b-form-select v-bind="inputAttrs" v-on="inputHandlers" :disabled="disabled || products.length === 0" :options="scopedProducts">
            <template #first>
              <!-- This is required to prevent bugs with Safari -->
              <option disabled value=""> {{ $t("product.text") }}</option>
            </template>
          </b-form-select>

          <ul v-if="tags.length > 0" class="list-inline d-inline-block mt-2">
            <li v-for="tag in tags" :key="tag" class="list-inline-item">
              <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled" variant="primary">{{ tag }}</b-form-tag>
            </li>
          </ul>
          <b-form-text v-else>
            <span class="text-danger">{{ $t("product.required") }}</span>
          </b-form-text>
        </template>
      </b-form-tags>
      <hr />

      <sweet-textarea
        class="mt-3"
        v-model="form.description"
        :isValid="!$v.form.description.$error"
        @input="$v.form.description.$touch()"
        type="text"
        layout="vertical"
        :placeholder="$t('common.description')"
        :label="$t('common.description')"
        :rows="5"
      />

      <!-- <h4 class="mt-4">ilişkili Sorular</h4>
      <filter-select
        key="questionFilter"
        id="questionFilter"
        ref="questionFilter"
        placeholder="Tedbir Kategorisi"
        :selected="form.questionDefinitions"
        :multiple="true"
        @filter="onPolicyQuestionSearch"
        @changed="onPolicyQuestionSelect"
      /> -->

      <sweet-button
        @click="save()"
        type="submit"
        :loading="isUpdating"
        :disabled="isUpdating || $v.form.$invalid"
        variant="success"
        icon="mdi mdi-check"
        size="sm"
        buttonClass="mt-2"
      >
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import SweetTextarea from "@c/form/sweet-textarea";
import { maxLength, minLength, required, numeric } from "vuelidate/lib/validators";

const state = "managementPolicy";

export default {
  components: {
    SweetTextarea,
  },
  data() {
    return {
      form: {
        no: undefined,
        name: undefined,
        category: undefined,
        description: undefined,
        products: [],
        // questionDefinitions: [],
      },
    };
  },
  validations: {
    form: {
      no: {
        numeric,
      },
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },

      category: {
        required,
      },
      description: {
        maxLength: maxLength(2000),
      },
      products: {
        required,
      },
    },
  },

  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };

        // this.form = JSON.parse(JSON.stringify(this.prepareFormForEdit(v)));
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },
  mounted() {},
  methods: {
    // async onPolicyQuestionSearch(value, callback) {
    //   const response = await this.$store.dispatch(`managementQuestion/paginate`, {
    //     options: { limit: 200 },
    //     query: {
    //       name: { value },
    //     },
    //   });
    //   callback(response.data?.docs ?? []);
    // },
    // onPolicyQuestionSelect(value) {
    //   this.form.questionDefinitions = value;
    // },
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch(`${state}/save`, this.form);

        this.form = {};
        this.$toast.success(this.$t("common.success"));
        this.$root.$emit("bv::toggle::collapse", `sidebar-new-policy`);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onPolicyCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`managementPolicyCategory/paginate`, {
        options: { limit: 200, sort: { [`name.${this.currentLanguage || tr}`]: "asc" } },
        query: {
          "scope.value": { value: "system", isObject: true },
          name: { value },
        },
      });

      callback(response.data?.docs ?? []);
    },
    onPolicyCategorySelect(value) {
      this.form.category = value;
    },

    rightPanelClosed() {},
  },
};
</script>
